export enum AddAssetType {
	Sermon = 0,
	Folder = 1,
	Series = 2,
	SermonManuscript = 3,
	SermonOutline = 4,
	Handout = 5,
	Devotional = 6,
	SmallGroupStudy = 7,
	PresentationSlides = 8,
	Notes = 9,
	SermonAudio = 10,
	SermonVideo = 11,
}